import { createFileRoute } from "@tanstack/react-router";
import LegacyRoutes from "@/legacy-routes";

/**
 * "/" falls through to the legacy react-router tree, which owns the Dashboard.
 *
 * The splat route in $.tsx does not match the root path, so this file is what
 * keeps "/" working. Delete it when the Dashboard becomes a real route.
 */
export const Route = createFileRoute("/")({
  component: LegacyRoutes,
});
